import React, { Fragment, useEffect, useMemo } from "react";
import { toast } from "react-toastify";

import { getCategories, getCategoryFromProduct } from "service/api";

import { Img, Text } from "components";
import Footer1 from "components/Footer1";
import Header from "components/Header";
import InfoRibbon from "components/InfoRibbon";

import "react-toastify/dist/ReactToastify.css";
import { BodyItem } from "../../components/BodyItem";
import { splitArrayTo } from "../../utils";
import { useNavigate } from "react-router-dom";
import { firstLetterUpper } from "../../helpers/sentence";
import ContextMenu from "../../components/ContextMenu";
import { LockIcon } from "../../assets/icons/lock_icon";
import { InformationIcon } from "../../assets/icons/information_icon";
import { SupportIcon } from "../../assets/icons/SupportIcon";
import { justArray } from "../../helpers/array";


const LandingpagePage = () => {
  const [categories, setCategories] = React.useState([]);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
  const images = useMemo(() => [
    "images/haier_home.gif",
    "images/img_rectangle7.png"
  ], []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        return (prevIndex + 1) % images.length;
      });
    }, 3000);
    return () => clearInterval(intervalId);

  }, [images]);

  React.useEffect(() => {
    callApi3();
  }, []);

  function callApi3() {
    const req = {
      path: {
        pid: "c6d12f0c-7e49-449b-b5e4-98713408de66",
        aid: "99b487f4-04d6-451d-b977-dca884d4f074"
      },
      data: {
        name: "product_by_category",
        type: "v2"
      }
    };

    let originalCategory;
    getCategories(req).then((res) => {
      originalCategory = justArray(res.data).reduce((a, b) => {
        return {
          ...a,
          [b.name]: b.image
        };
      }, {});
      return getCategoryFromProduct(req);
    }).then((res) => {
      const c = justArray(res?.data).map(x => {
        return {
          ...x,
          image: `${originalCategory[x?.category] ?? x?.image}`.split(',')[0],
          product_name: x?.name,
          name: x?.category?.split(',')[0]?.split('-')[0],
          size: originalCategory[x?.category] ? "cover" : "contain"
        };
      }).reduce((a, b) => {
        return {
          ...a,
          [b.name]: b
        }
      },{});
      setCategories(splitArrayTo(Object.values(c), 2));
    })
      .catch((err) => {
        console.error(err);
        toast.error("Fail to retrieve categories");
      });
  }

  const navigate = useNavigate();

  return (
    <div className="flex flex-col font-inter items-center justify-start mx-auto w-full"
         style={{ backgroundColor: "#E8E8E8" }}>
      <InfoRibbon />
      <div className="flex flex-col items-center justify-start w-full">
        <Header showSearch={false} />
        <div className="h-[371px] w-full">
          {
            images.map((image, index) => {
              return (
                <Fragment key={`${image}_${index}`}>
                  <Img
                    // style={{display: currentImageIndex===index?"block":"none"}}
                    className={`h-[371px] sm:h-auto object-cover w-full absolute ${currentImageIndex === index ? "visible-img" : "hidden-img"}`}
                    src={image}
                    alt="rectangleseven"
                  />
                </Fragment>
              );
            })
          }
        </div>
      </div>
      <div className="flex flex-col items-center justify-start mx-auto px-8 md:px-5 w-full">
        <div className="flex flex-col items-center justify-start w-full">
          <div style={{ marginTop: 8 }} />
          <ContextMenu />
          {/*<h1 style={{ marginTop: 8, marginBottom: 8 }}*/}
          {/*    className={"text-2xl font-bold"}>FLAGSHIP PRODUCTS</h1>*/}
          <div style={{ maxWidth: 1200, margin: "auto", width: "100%" }}>
            {
              categories?.map((x, ix) => {
                return (
                  <div key={`${ix}_manu_item`} style={{ flexDirection: "row", width: "100%", display: "flex" }}>
                    {
                      x?.map((item, index) => {
                        return (
                          <button onClick={() => {
                            // addSearchKeyword(item?.name);
                            navigate(`/productspage?category=${item.category}`);
                          }} style={{ flexGrow: 1, margin: 10 }} key={`${index}_manu_item_inner`}>
                            <BodyItem cover={item?.size === "cover"} name={firstLetterUpper(item?.name)}
                                      image={item?.image} />
                          </button>
                        );
                      })
                    }
                  </div>
                );
              })
            }
          </div>
          <button style={{ padding: "8px 20px", backgroundColor: "#191919", borderRadius: 16, height: 70 }}
                  onClick={() => {
                    navigate(`/productspage`);
                  }}
                  className="cursor-pointer mt-[16px] flex flex-row items-center">
            <Text
              className="text-sm text-white-A700 tracking-[0.25px]"
              style={{ fontSize: 36 }}
            >
              {"SHOP NOW"}
            </Text>
          </button>
          <div style={{ height: 58 }} />
          <div style={{ padding: 24, backgroundColor: "#D9D9D9", width: "100%" }}
               className="flex flex-row !rounded-[8px]">
            <div className="flex-grow flex flex-col items-start">
              <div className="flex flex-col justify-center items-center">
                <LockIcon />
                <Text className="mt-4">Well secured</Text>
                <Text>and protected site</Text>
              </div>
            </div>
            <div className="flex-grow flex flex-col">
              <div className="flex flex-col justify-center items-center">
                <SupportIcon />
                <Text className="mt-4">24/7 support</Text>
                <Text>and assistance</Text>
              </div>
            </div>
            <div className="flex-grow flex flex-col items-end justify-end">
              <div className="flex flex-col justify-center items-center">
                <InformationIcon />
                <Text className="mt-4">Affordable &</Text>
                <Text>reliable products</Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer1 className="bg-blue_gray-900 flex items-center justify-center mt-[69px] md:px-5 w-full" />
    </div>
  );
};

export default LandingpagePage;
